import { formatTime, formatTimeWithTimeZone } from "@clipboard-health/date-time";
import { differenceInMinutes } from "date-fns";

interface FormatInterviewEtaMessageParams {
  interviewStart: Date;
  selectedEta: Date;
  workplaceTimezone: string;
  additionalMessage?: string;
}

/**
 * Format a message to send to the workplace about the worker's ETA for an interview.
 * If the selected ETA is within 1 minute of the interview start, indicates the worker is on time.
 * Otherwise, indicates they are running late.
 */
export function formatInterviewEtaMessage(params: FormatInterviewEtaMessageParams): string {
  const { interviewStart, selectedEta, workplaceTimezone, additionalMessage } = params;

  const interviewTime = formatTime(interviewStart, { timeZone: workplaceTimezone });
  const arrivalTime = formatTimeWithTimeZone(selectedEta, { timeZone: workplaceTimezone });
  const isOnTime = Math.abs(differenceInMinutes(selectedEta, interviewStart)) <= 1;

  const suffix = additionalMessage ? ` ${additionalMessage}` : "";

  if (isOnTime) {
    return `Hi, I am going to be on time. I will arrive by ${arrivalTime}.${suffix}`;
  }

  return `Hi, I'm running late to my ${interviewTime} interview. I will arrive by ${arrivalTime}.${suffix}`;
}
